const estimate = (state = {}, action) => {
  switch (action.type) {
    case "SET_ESTIMATE":
      return { ...state, ...action.details };
    case "SET_DATE_RANGE":
      return { ...state, date_range: action.date_range };
    case "SET_ESTIMATE_LOADING":
      return { ...state, loading: action.loading };
    case "SET_ESTIMATE_SUCCESS":
      return { ...state, success: action.success };
    case "SET_ESTIMATE_ERROR":
      return { ...state, error: action.error };
    case "SET_PREVIOUS_VALUES":
      return { ...state, previousValues: action.previousValues };
    default:
      return state;
  }
};

export default estimate;
